import React, { useEffect, useRef, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"
const CONSULTA_MS = 15000
const MAX_NA_TELA = 4

export const ROTULO_CONDUCAO: Record<string, { rotulo: string; icone: string; cor: string }> = {
  colisao:           { rotulo: "Colisão",           icone: "💥", cor: "#ef4444" },
  corte_energia:     { rotulo: "Corte de energia",  icone: "🔌", cor: "#f59e0b" },
  frenagem_brusca:   { rotulo: "Frenagem brusca",   icone: "🛑", cor: "#f59e0b" },
  aceleracao_brusca: { rotulo: "Aceleração brusca", icone: "🚀", cor: "#f59e0b" },
  curva_brusca:      { rotulo: "Curva brusca",      icone: "↪️", cor: "#f59e0b" },
}

function bipar() {
  try {
    const Ctx = (window as any).AudioContext || (window as any).webkitAudioContext
    if (!Ctx) return
    const c = new Ctx(), o = c.createOscillator(), g = c.createGain()
    o.frequency.value = 880; g.gain.value = 0.08; o.connect(g); g.connect(c.destination); o.start(); o.stop(c.currentTime + 0.25)
    setTimeout(() => c.close && c.close(), 600)
  } catch { /* o navegador pode bloquear som antes do primeiro clique: sem problema */ }
}

// Aviso na tela (canto inferior direito) dos alertas de conducao NOVOS: colisao, frenagem/aceleracao/curva brusca e corte de energia.
// Consulta a cada 15 s; a 1a consulta so pega o "marco" (nao mostra nada antigo). Colisao fica na tela ate ser fechada.
export default function AlertasConducaoPopup({ aoAbrirAlertas }: { aoAbrirAlertas: () => void }) {
  const [itens, setItens] = useState<any[]>([])
  const marco = useRef<number | null>(null)
  const timers = useRef<any[]>([])

  useEffect(() => {
    let vivo = true
    const consultar = async () => {
      if (document.hidden && marco.current != null) return            // aba em segundo plano: na volta pega tudo o que passou
      try {
        const r = await axios.get(`${API}/alertas-conducao/novos`, { params: marco.current == null ? {} : { desde: marco.current } })
        if (!vivo) return
        const novos: any[] = r.data?.itens || []
        marco.current = r.data?.ultimo_id ?? marco.current
        if (novos.length) {
          setItens((l) => [...novos.map((n) => ({ ...n, chave: `${n.id}` })).reverse(), ...l].slice(0, 12))
          // some sozinho depois de 20 s (colisao fica ate ser fechada)
          novos.filter((n) => n.tipo_alerta !== "colisao").forEach((n) => timers.current.push(setTimeout(() => setItens((l) => l.filter((x) => x.chave !== `${n.id}`)), 20000)))
          bipar()
        }
      } catch { /* sem permissao, sem rede ou sem cliente: tenta de novo no proximo ciclo */ }
    }
    consultar()
    const t = setInterval(consultar, CONSULTA_MS)
    return () => { vivo = false; clearInterval(t); timers.current.forEach(clearTimeout); timers.current = [] }
  }, [])

  if (!itens.length) return null
  const fechar = (chave: string) => setItens((l) => l.filter((i) => i.chave !== chave))
  const visiveis = itens.slice(0, MAX_NA_TELA)
  return (
    <div role="region" aria-label="Alertas de condução" style={{ position: "fixed", right: 16, bottom: 16, zIndex: 3000, display: "flex", flexDirection: "column", gap: 10, width: 340, maxWidth: "calc(100vw - 32px)" }}>
      {visiveis.map((i) => {
        const t = ROTULO_CONDUCAO[i.tipo_alerta] || { rotulo: "Alerta", icone: "🔔", cor: "#f59e0b" }
        return (
          <div key={i.chave} role="alert" style={{ background: "#13233b", border: `1px solid ${t.cor}`, borderLeft: `5px solid ${t.cor}`, borderRadius: 10, padding: "12px 14px", boxShadow: "0 8px 28px rgba(0,0,0,.45)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: t.cor }}>{t.icone} {t.rotulo}</div>
              <button aria-label="Fechar aviso" onClick={() => fechar(i.chave)} style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", fontSize: 16, lineHeight: 1 }}>✕</button>
            </div>
            <div style={{ fontSize: 13, color: "#f1f5f9", marginTop: 4 }}><b>{i.ativo_nome || "Veículo"}</b>{i.ativo_placa && i.ativo_placa !== i.ativo_nome ? ` · ${i.ativo_placa}` : ""}</div>
            <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 2 }}>
              {i.motorista_nome ? `Motorista: ${i.motorista_nome}` : "Motorista não identificado"}{i.velocidade != null && i.tipo_alerta !== "corte_energia" ? ` · ${Math.round(Number(i.velocidade))} km/h` : ""} · {new Date(i.criado_em).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
            </div>
            <div style={{ marginTop: 8 }}><button className="btn btn-ghost" style={{ padding: "3px 10px", fontSize: 11 }} onClick={() => { fechar(i.chave); aoAbrirAlertas() }}>Ver alertas</button></div>
          </div>
        )
      })}
      {itens.length > MAX_NA_TELA && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "right" }}>+ {itens.length - MAX_NA_TELA} alerta(s) na tela de Alertas</div>}
    </div>
  )
}
